var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.activityStatus === '0')?_c('img',{attrs:{"src":require("@/assets/img/hdbmz.png")}}):(_vm.activityStatus === '1')?_c('img',{attrs:{"src":require("@/assets/img/hdjxz.png")}}):_c('img',{attrs:{"src":require("@/assets/img/tag1.png")}})
}
var staticRenderFns = []

export { render, staticRenderFns }